// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"130":"ac3829be","760":"23d13a6c"}[chunkId] + ".chunk.css";
};